import { render, staticRenderFns } from "./courseTop.vue?vue&type=template&id=b99b384e&scoped=true"
import script from "./courseTop.vue?vue&type=script&lang=js"
export * from "./courseTop.vue?vue&type=script&lang=js"
import style0 from "./courseTop.vue?vue&type=style&index=0&id=b99b384e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99b384e",
  null
  
)

export default component.exports